import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { useState, useReducer } from "react"
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { useEffect } from "react"
import Loader from "../../../shared/Loader/Loader"
import AddNewBillingProvider from "../BillingProvider/AddNewBillingProvider"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import { connect, useSelector } from "react-redux"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import Pagination from "../../../shared/Pagination/Pagination"
import usePagination from "../../../../customhooks/usePagination"

const BillingProvider = (props) => {
    const { type, Settings } = { ...props };

    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages,handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Billing Provider')?.IsDeleted
    const API_URL = enumUtil.controller.General
    const [BillingProviderID, setBillingProviderID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [IsOpenBillingProvider, setIsOpenBillingProvider] = useState(false);
    const [BillingProviderData, setBillingProviderData] = useState([]);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(Settings?.DefaultPageView === "Card View" ? true : false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: true
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { setPageNo(PageNo - 1); }
    // const NextPage = () => { setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    ///////////
    const LoadData = (param, types) => {
        setIsLoading(true)
        // setBillingProviderData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param;
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.BillingProvider,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            console.log(response);
            handleGridHeader({ defaultData: response.Rows })
            setBillingProviderData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenBillingProvider(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setBillingProviderData([])
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (BillingProviderData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenBillingProvider(true)
                }
            }

        })
    }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setEnterParam(e.target.value)
            setSearchParam(EnterParam)
            SearchByParam(searchParam)
            LoadData(searchParam, "searchParam")
        }
    }
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])

    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name, row, type)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const AddBillingProvider = (ID) => {
        setIsOpenBillingProvider(true)
        setNpiModal(true)
        setBillingProviderID(ID)
    }
    const CloseBillingProvider = () => {
        setIsOpenBillingProvider(false)
    }
    const DeleteBillingProvider = () => {
        setIsOpenBillingProvider(false)
        setIsClose((Math.random()));
    }
    const proceedHeader = () => {
        return <p className="heading">Proceed with NPI Registry</p>;
    };
    const [npiModal, setNpiModal] = useState(false)
    const onCloseProocedNpi = () => {
        setNpiModal(false)
    }
    let PopupScreen = "";
    if (IsOpenBillingProvider) {
        PopupScreen = <AddNewBillingProvider IsOpenBillingProvider={IsOpenBillingProvider} onClose={CloseBillingProvider} onDeleteBillingProvider={DeleteBillingProvider}
            BillingProviderID={BillingProviderID}
            npiModal={npiModal} proceedHeader={proceedHeader} onCloseProocedNpi={onCloseProocedNpi} type={type} />
    }
    const columns = [

        {
            key: 'ProfileName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'ProfileName'} sortIcon={true} type={'string'} colKey={'ProfileName'} data={BillingProviderData} setData={setBillingProviderData} />),
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddBillingProvider(row.BillingProviderID)}>{row.ProfileName} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.BillingProviderID, row.ProfileName)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {console.log('object', copiedText, `${row.BillingProviderID}-${row.ProfileName}`, copiedText[`${row.BillingProviderID}-${row.ProfileName}`])}
                            {copiedText[`${row.BillingProviderID}-${row.ProfileName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'BillingProviderName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Name'} sortIcon={true} type={'string'} colKey={'BillingProviderName'} data={BillingProviderData} setData={setBillingProviderData} />),
        },
        {
            key: 'LocationName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Location'} sortIcon={true} type={'string'} colKey={'LocationName'} data={BillingProviderData} setData={setBillingProviderData} />),
            width: 150,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.LocationName}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.BillingProviderID, row.LocationName)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.BillingProviderID}-${row.LocationName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'ProviderName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Provider'} sortIcon={true} type={'string'} colKey={'ProviderName'} data={BillingProviderData} setData={setBillingProviderData} />),
            width: 150,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.ProviderName}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopyText(row.BillingProviderID, row.ProviderName)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.BillingProviderID}-${row.ProviderName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'InsuranceName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'InsuranceName'} data={BillingProviderData} setData={setBillingProviderData} />),
            width: 150,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.InsuranceName}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.BillingProviderID, row.InsuranceName)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.BillingProviderID}-${row.InsuranceName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'ReportingType',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Reporting Type'} sortIcon={true} type={'string'} colKey={'ReportingType'} data={BillingProviderData} setData={setBillingProviderData} />),
            width: 150,
        },

        {
            key: 'NPI',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'NPI'} sortIcon={true} type={'number'} colKey={'NPI'} data={BillingProviderData} setData={setBillingProviderData} />),
            width: 120,
        },
        {
            key: 'TaxID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Tax ID'} sortIcon={true} type={'number'} colKey={'TaxID'} data={BillingProviderData} setData={setBillingProviderData} />),
            flex: 1,
        },

    ]

    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
        const handleClearSearch = () => {
        setSearchParam('')
    }
    const BillingProvBody = () => {
        return (
            <>
                <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>
                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by name or id…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter} value={searchParam} />
                                   {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddBillingProvider}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                searchButton={searchButton}
                                Key={615}
                                Name={'Billing Prov'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {show ?
                    <>
                        <Card
                            AddNew={AddBillingProvider}
                            Data={BillingProviderData}
                            API_URL={API_URL}
                            TableName={enumUtil.enumAPITableName.BillingProvider}
                            handleDelete={DeleteBillingProvider}
                            ID={BillingProviderID}
                            dropDown={DropDowns?.BillingProvider}
                            isLoading={isLoading}
                            Key={615}
                            Name={'Billing Prov'}
                            IsDeleteAllowed={IsDeleteAllowed}
                        />
                        {paginationSection}
                        {/* <Pagination
                            PerPage={PerPage}
                            PageNo={PageNo}
                            TotalPages={TotalPages}
                            handlePageClick={handlePageClick}
                            PreviousPage={PreviousPage}
                            handleFingByCreteria={handleFingByCreteria}
                            NextPage={NextPage}
                        /> */}
                    </>
                    : (
                        <div className="table-view SetupTable location_grid">
                            <Table
                                columns={columns}
                                rows={BillingProviderData}
                                height='500px'
                                rowClass={rowClass}
                                // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                dynamicClass='fill-grid DataGrid-Table hk-exp-table'
                                rowHeight={25}
                                PerPage={PerPage}
                                PageNo={PageNo}
                                TotalPages={TotalPages}
                                handlePageClick={handlePageClick}
                                PreviousPage={PreviousPage}
                                handleFingByCreteria={handleFingByCreteria}
                                NextPage={NextPage}
                                Key={615}
                                Name={'Billing Prov'}
                                isLoading={isLoading}
                                TableName={'BillingProvider'}
                                handleSelectData = {handleSelectData}
                                LoadData={() => LoadData(searchParam)}
                                ClearSearch={handleClearSearch}
                            />
                        </div>
                    )
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         setBillingProviderData(prev=>{
    //             console.log("prev",prev)
    //             return prev;
    //         })
    //         console.log("BillingConsole")
    //         if(BillingProviderData?.length == 0 && isNull(searchParamType)){
    //             console.log("BillingConsole")
    //             setIsOpenBillingProvider(true)
    //         }       
    //     }
    // },[BillingProviderData])
    return (
        <>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {BillingProviderData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {IsOpenBillingProvider ? <>{PopupScreen}</> : <>{BillingProvBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </>
                :
                <>
                    {PopupScreen}
                    {BillingProvBody()}
                </>
            }

        </>
    )
}

const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(BillingProvider);